import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import QtyInput from 'ui/forms/qty_input'

import { useTranslation } from 'react-i18next'
import {
  Col,
  Input,
  ListGroup,
  ListGroupItem,
  Row
} from 'reactstrap'

import cn from 'classnames'
import styled from 'styled-components'
import { currency } from 'i18n/config'
import s0000 from 'img/axis/S0000.png'
import ss000 from 'img/axis/SS000.png'
import p0000 from 'img/axis/P0000.png'
import pp000 from 'img/axis/PP000.png'
import pw000 from 'img/axis/PW000.png'

const vehicleThumbnail = (serviceCode) => {
  if (serviceCode == 'S0000') {
    return s0000
  } else if (serviceCode == 'S0000') {
    return ss000
  } else if (serviceCode == 'P0000') {
    return p0000
  } else if (serviceCode == 'PP000') {
    return pp000
  } else if (serviceCode == 'PW000') {
    return pw000
  } else {
    return ''
  }
}

const VehicleCard = styled(ListGroupItem)`
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  .vehicle-card-title {
    transition: color 0.2s ease;
  }

  &:hover {
    border-color: var(--bs-primary-border-subtle) !important;
    box-shadow: var(--bs-box-shadow) !important;
  }

  &:hover .vehicle-card-title {
    color: var(--bs-primary) !important;
  }
`

const VehicleImage = styled.img`
  width: 180px;
  height: 120px;
  object-fit: contain;
`

const Icon = styled.i`
  width: 20px;
`

const FeePrice = styled.span`
  min-width: 75px;
`

const VehicleSummary = styled.div`
  border-top: var(--bs-border-width) solid var(--bs-border-color);

  @media (min-width: 768px) {
    border-top: 0;
    border-left: var(--bs-border-width) solid var(--bs-border-color);
    padding-left: 1.5rem;
  }
`

const VehiclesModule = (props) => {
  const { machine, status, config } = props
  const [current, send] = machine
  const {context} = current
  // const quote = context.quote_values
  // const places = config.product.purchase_info.places
  // const accommodation = config.product.purchase_info.accommodation

  const { t, i18n } = useTranslation()
  const {
    vehicle,
    vehicles,
    vehicleFeeQuantities
  } = current.context

  const onVehicleSelected = (vehicle) => {
    send({
      type: 'VEHICLE_SELECTION',
      vehicle
    })
  }

  const onFeeQuantityChange = ({
    serviceCode,
    feeDescription,
    quantity
  }) => {
    send({
      type: 'VEHICLE_FEE_QTY_CHANGE',
      serviceCode,
      feeDescription,
      quantity
    })
  }

  const handleKeyDown = (event, vehicle) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onVehicleSelected(vehicle)
    }
  }

  const Fee = ({
    fee,
    serviceCode,
    quantity
  }) => {
    const increment = () => {
      if (quantity >= 99) return

      onFeeQuantityChange({
        serviceCode,
        feeDescription: fee.description,
        quantity: quantity + 1
      })
    }

    const decrement = () => {
      if (quantity <= 0) return

      onFeeQuantityChange({
        serviceCode,
        feeDescription: fee.description,
        quantity: quantity - 1
      })
    }

    return (
      <ListGroupItem className="px-0 py-2 bg-transparent">
        <Row className="g-2 align-items-center">
          <Col xs={12} sm>
            <div>
              {fee.description}
            </div>
          </Col>

          <Col xs={12} sm="auto">
            <div
              className="
                d-flex
                align-items-center
                justify-content-between
                justify-content-sm-end
                gap-3
              "
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
            >
              <FeePrice className="text-nowrap text-end">
                {t('{{amount}} por unidad', {amount: currency(fee.amount)})}
              </FeePrice>

              <QtyInput
                min={0}
                max={99}
                value={quantity}
                onIncrement={increment}
                onDecrement={decrement}
              />
            </div>
          </Col>
        </Row>
      </ListGroupItem>
    )
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed'
            ? send('REOPEN_VEHICLESSTEP')
            : null
        }
      >
        <span>
          <i
            className="fa fa-car me-2"
            aria-hidden="true"
          />

          {status === 'completed' ? vehicle?.vehicle_type?.description : i18n.t('axis_vehicle_module.vehicle_title')}
        </span>
      </ModuleHeader>

      <ModuleBody status={status}>
        <ListGroup className="gap-3">
          {vehicles?.map((v) => {
            const {
              vehicle_type,
              total,
              max_passengers,
              service_level,
              fees,
              service_name,
              marketing_title,
              marketing_description,
              service_description,
              highlights
            } = v

            console.log(v)

            const serviceCode = service_level.code

            const vehicleThumbnailImg = vehicleThumbnail(serviceCode)

            const radioId = `vehicle-${serviceCode}`

            const selected =
              vehicle?.service_level?.code === serviceCode

            const feeQuantities =
              vehicleFeeQuantities?.[serviceCode] || {}

            const feesTotal = fees?.reduce((sum, fee) => {
              const quantity = feeQuantities[fee.description] || 0

              return sum + (
                quantity * Number(fee.amount || 0)
              )
            }, 0) || 0

            const totalAmount =
              Number(total?.amount || 0) + feesTotal

            return (
              <VehicleCard
                key={serviceCode}
                role="button"
                tabIndex={0}
                onClick={() => onVehicleSelected(v)}
                onKeyDown={(event) => handleKeyDown(event, v)}
                className={cn(
                  'rounded-3 border-3 p-3 p-md-4 bg-body',
                  {
                    'border-primary shadow': selected
                  }
                )}
              >
                <Row className="g-4">
                  <Col md={9}>
                    <Row className="g-3 align-items-start">
                      <Col>
                        <h2 className="vehicle-card-title h4 fw-bold text-primary-emphasis mb-3">
                          {service_name}
                        </h2>

                        <div className="d-flex flex-column gap-2">
                          {max_passengers && (max_passengers < 99) && (
                            <div className="d-flex align-items-center text-body">
                              <Icon
                                className="fa fa-users text-secondary me-2"
                                aria-hidden="true"
                              />

                              <span>
                                {t('Máximo {{count}} pasajeros', {
                                  count: max_passengers
                                })}
                              </span>
                            </div>
                          )}

                          {highlights && highlights.map((text) => (
                            <div className="d-flex align-items-center text-body">
                              <Icon
                                className="fa fa-check text-success me-2"
                                aria-hidden="true"
                              />

                              <span>
                                {text}
                              </span>
                            </div>
                          ))}

                          {marketing_description && (
                            <div className="d-flex align-items-center text-body">
                              <Icon
                                className="fa fa-bus text-secondary me-2"
                                aria-hidden="true"
                              />

                              <span>
                                {marketing_description}
                              </span>
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs="auto">
                        {vehicleThumbnailImg &&
                          <VehicleImage
                            src={vehicleThumbnailImg}
                            alt={vehicle_type.description}
                            className="img-fluid"
                          />
                        }
                      </Col>
                    </Row>

                    {!!fees?.length && (
                      <div className="mt-4">
                        <h3 className="h6 fw-bold mb-2">
                          {t('Añade extras (opcional)')}
                        </h3>

                        <ListGroup flush>
                          {fees.map((fee) => (
                            <Fee
                              key={fee.description}
                              fee={fee}
                              serviceCode={serviceCode}
                              quantity={feeQuantities[fee.description] || 0}
                            />
                          ))}
                        </ListGroup>
                      </div>
                    )}
                  </Col>

                  <Col md={3}>
                    <VehicleSummary
                      className="
                        h-100
                        pt-3
                        pt-md-0
                        d-flex
                        flex-column
                        align-items-center
                        justify-content-center
                        text-center
                      "
                    >
                      <div
                        className="d-flex align-items-center justify-content-center mb-3"
                        onClick={(event) => event.stopPropagation()}
                        onKeyDown={(event) => event.stopPropagation()}
                      >
                        <label
                          htmlFor={radioId}
                          className="
                            d-flex
                            align-items-center
                            justify-content-center
                            gap-2
                            mb-0
                          "
                          style={{ cursor: 'pointer' }}
                        >
                          <Input
                            id={radioId}
                            type="radio"
                            className="form-check-input m-0"
                            name="vehicle"
                            checked={selected}
                            onChange={() => onVehicleSelected(v)}
                            aria-label={t(
                              'Elegir {{vehicle}}',
                              {
                                vehicle: vehicle_type.description
                              }
                            )}
                          />

                          <span
                            className={cn(
                              'fw-semibold',
                              selected
                                ? 'text-primary'
                                : 'text-body-secondary'
                            )}
                          >
                            {selected
                              ? t('Elegido')
                              : t('Elegir')}
                          </span>
                        </label>
                      </div>

                      <div className="text-center">
                        <div className="small text-secondary mb-1">
                          {t('Total')}
                        </div>

                        <div className="fs-3 fw-bold text-primary-emphasis lh-1">
                          {currency(totalAmount)}
                        </div>
                      </div>
                    </VehicleSummary>
                  </Col>
                </Row>
              </VehicleCard>
            )
          })}
        </ListGroup>
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default VehiclesModule
